import React from 'react'
import styled from 'styled-components'

import Spinner from 'components/Spinner'

import useDevicesHasMetrics from 'hooks/useDevicesHasMetrics'

export default function DeviceList () {
  const { deviceIds, areDeviceIdsLoaded } = useDevicesHasMetrics()

  if (!areDeviceIdsLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <S.Container>
      <h2>Devices</h2>
      {deviceIds.length === 0 ? (
        <p >No devices found.</p>
      ) : (
        <ul>
          {deviceIds.map((id) => (
            <li
              key={id}
            >
              {id}
            </li>
          ))}
        </ul>
      )}
    </S.Container>
  )
}

const S = {
  Container: styled.div`
    padding: 20px 0px 10px 0px;
  `
}
